import { combineReducers } from 'redux';
import userAuthToken from './userAuthToken';

export default combineReducers({
  userAuthToken: userAuthToken
});
